<template>
  <div v-if="hasPermission(permissions.usersList)">
    <content-header>
      {{ isCustomer ? $t('customers') : $t('users') }}
      <VueToggles
          :value="isCustomer"
          checkedText="Yes"
          uncheckedText="No"
          @click="switchChange"
      />
    </content-header>
    <v-content>
      <BootstrapTable
          :rows="rows"
          :columns="columns"
          :config="config"
          :total-rows="totalRecords"
          :actions="actions"
          @on-change-query="onChangeQuery"
          @on-create="$router.push({name: 'users.create'})"
      >
        <template slot="empty-results">{{ $t('noResultsFound') }}</template>
        <template slot="pagination-info" slot-scope="props">
          <template v-if="props.currentPageRowsLength !== 0">{{totalRecords}} {{ $t('totalRecords') }}</template>
          <template v-else>{{ $t('noResultsFound') }}</template>
        </template>
        <template slot="phone" slot-scope="props">
          {{ props.row.phone.replace('+964', '0') }}
          <span v-if="props.row.phone2 !== null"> - {{ props.row.phone2 }}</span>
        </template>
        <template slot="controls" slot-scope="props" v-if="hasPermission(permissions.usersShow)">
          <control-buttons
              :props="props"
              :show-link="hasPermission(permissions.usersShow) && 'users.show'"
          />
        </template>
      </BootstrapTable>
      <is-loading v-if="isLoading" />
    </v-content>
  </div>
</template>

<script>
import Content from "@/components/Content";
import ContentHeader from "@/components/ContentHeader";
import {User} from "@/models/User";
import IsLoading from "@/components/IsLoading";
import ControlButtons from "@/components/ControlButtons";
import {permissions, serverParams, tableActions, tableConfigure} from "@/plugins/constants";
import BootstrapTable from "@/components/Table/BootstrapTable";

export default {
  name: "UserList",
  components: {ControlButtons, IsLoading, 'v-content': Content, ContentHeader,  BootstrapTable},
  data() {
    return {
      isLoading: false,
      isCustomer: false,
      model: new User(),
      columns: [],
      rows: [],
      actions: tableActions(this.hasPermission(permissions.usersShow)),
      totalRecords: 0,
      config: tableConfigure(this.$t('usersList')),
      serverParams: serverParams,
      selectedRows: [],
      permissions: permissions
    };
  },
  beforeMount() {
    this.columns  = this.model.getColumns();
  },
  methods: {
    loadData(reset = false) {
      if (reset) {
        serverParams._start   = 0
        serverParams._end     = 10
        serverParams._sort    = ''
        serverParams._order   = ''
        serverParams._search  = ''
      }
      this.isLoading = true;
      this.$store.dispatch('users/GET_ALL', this.serverParams)
          .then((response) => {
            this.rows         = response.data
            this.totalRecords = parseInt(response.headers['x-total-count'])
            this.isLoading    = false
          })
          .catch(() => this.isLoading = false);
    },
    onChangeQuery(queryParams) {
      serverParams._start   = (queryParams.page - 1) * queryParams.per_page
      serverParams._end     = queryParams.page * queryParams.per_page
      serverParams._sort    = queryParams.sort[0] ? queryParams.sort[0].name : ''
      serverParams._order   = queryParams.sort[0] ? queryParams.sort[0].order : ''
      serverParams._search  = queryParams.global_search ?? ''
      this.loadData()
    },
    switchChange() {
      this.isCustomer = !this.isCustomer;
      this.resetServerParams();
      this.serverParams.custom_params = {
        isCustomer: this.isCustomer
      };
      this.loadData();
    },
    resetServerParams() {
      this.serverParams = {
        _start: 0,
        _end: 10,
        _sort: '',
        _order: '',
        _search: '',
        custom_params: {}
      };
    }
  }
}
</script>
